import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  DocumentsState,
  Document,
  DocumentsListData,
} from '../../types/documents.types';

const initialState: DocumentsState = {
  documents: [],
  selectedDocument: null,
  loading: false,
  error: null,
  pagination: {
    page: 1,
    pageSize: 10,
    totalPages: 0,
    totalRecords: 0,
    hasMorePages: false,
  },
  search: '',
};

const documentsSlice = createSlice({
  name: 'documents',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setDocuments: (state, action: PayloadAction<DocumentsListData>) => {
      state.documents = action.payload.documents;
      state.pagination = {
        ...state.pagination,
        totalPages: action.payload.totalPages,
        totalRecords: action.payload.totalRecords,
        hasMorePages: action.payload.hasMorePages,
      };
      state.loading = false;
      state.error = null;
    },
    setSelectedDocument: (state, action: PayloadAction<Document | null>) => {
      state.selectedDocument = action.payload;
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.pagination.page = action.payload;
    },
    setPageSize: (state, action: PayloadAction<number>) => {
      state.pagination.pageSize = action.payload;
    },
    setSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
      state.pagination.page = 1;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearSelectedDocument: (state) => {
      state.selectedDocument = null;
    },
    addDocument: (state, action: PayloadAction<Document>) => {
      state.documents.unshift(action.payload);
      state.pagination.totalRecords += 1;
    },
    updateDocument: (state, action: PayloadAction<Document>) => {
      const index = state.documents.findIndex((doc) => doc.id === action.payload.id);
      if (index !== -1) {
        state.documents[index] = action.payload;
      }
      if (state.selectedDocument?.id === action.payload.id) {
        state.selectedDocument = action.payload;
      }
    },
    deleteDocument: (state, action: PayloadAction<string>) => {
      state.documents = state.documents.filter((doc) => doc.id !== action.payload);
      state.pagination.totalRecords -= 1;
      if (state.selectedDocument?.id === action.payload) {
        state.selectedDocument = null;
      }
    },
  },
});

export const {
  setLoading,
  setError,
  setDocuments,
  setSelectedDocument,
  setPage,
  setPageSize,
  setSearch,
  clearError,
  clearSelectedDocument,
  addDocument,
  updateDocument,
  deleteDocument,
} = documentsSlice.actions;

export default documentsSlice.reducer;
